import {
    Component,
    InputSignal,
    inject,
    input, ChangeDetectionStrategy
} from "@angular/core";
import {SessionModel} from "../../session/session.model";
import {CustomerDetails} from "../customer-details.service";

@Component({
    selector: "woa-customer-details-panel",
    templateUrl: "./customer-details-panel.component.html",
    styleUrl: "./customer-details-panel.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomerDetailsPanelComponent {
    public sessionModel: SessionModel = inject(SessionModel);

    public readonly customerDetails: InputSignal<CustomerDetails> = input.required<CustomerDetails>();
}
